<template>
  <div class="notify-wrap">
    <el-dialog
      :visible.sync="visible"
      title="支付通知"
      class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="false"
      width="30%"
    >
      <div class="notify-body">
        您已加入 [{{ pendingPayInfo.ownerCompanyName }}]
        供应商库，请在支付入库费用后参与项目
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="toPay">去支付</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { purchaseAllTypeDict } from '@/dictionary/project/common'
import { getUnpaidChargeListApi } from '@/api/company'

/**
 * 五菱供应商库入库费用通知
 */
export default {
  name: 'WlSupplierLibFeeNotify',

  data() {
    return {
      visible: false,
      pendingPayInfo: {}
    }
  },

  computed: {
    ...mapState('company', ['companyId'])
  },

  created() {
    this.checkSupplierPayable()
  },

  methods: {
    /**
     * 检查当前供应商是否需要支付五菱供应商库入库费用
     */
    checkSupplierPayable() {
      getUnpaidChargeListApi({
        purchaseTypes: purchaseAllTypeDict.RECRUIT.value
      })
        .then(res => {
          const list = (res.data || []).filter(item => item.isOwnerWuling)
          this.pendingPayInfo = list[0] || {}
          if (this.pendingPayInfo?.tradeId) {
            this.visible = true
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    toPay() {
      window.open(
        `${process.env.VUE_APP_PORTAL_URL}/project/pay/recruit-service?paymentId=${this.pendingPayInfo.tradeId}&supplierId=${this.pendingPayInfo.supplierId}`,
        '_blank'
      )
    }
  }
}
</script>

<style scoped lang="scss"></style>
